import { createSelector } from 'reselect'
import { values, some, filter, keys, uniqBy } from 'lodash'

import { getCurrentMenuItemsFilteredByCategory } from './items'
import { getCurrentMenuId } from './appState'
import { getSelectedMenusIds } from './config'
import { ALL_ID, ALL_LABEL, FAVORITES_ID, FAVORITES_LABEL, getSelectedCategory } from '../VNCategories/Selectors'

const getCategories = (state) => state.categories.byMenuId

export const getIsMenuItemsLoading = (state) => state?.categories?.isMenuItemsLoading ?? false

export const getCurrentMenuCategories = createSelector(
  getCategories,
  getCurrentMenuId,
  (categories, currentMenuId) => categories?.[currentMenuId],
)

export const getCategoriesWithExistingItems = (state) =>
  filter(values(getCurrentMenuCategories(state)?.byId), (category) =>
    some(getCurrentMenuItemsFilteredByCategory(state, category.itemCategoryUuid)),
  )

export const getUniqCategoriesWithExistingItems = createSelector(getCategoriesWithExistingItems, (categories) =>
  uniqBy(categories, 'name'),
)

export const getAreCategoriesLoaded = createSelector(getCategories, getSelectedMenusIds, (categories, selectedIds) => {
  const categoryKeys = keys(categories)
  return selectedIds.every((id) => categoryKeys.includes(id))
})

/**
 * Selects the name of the currently selected category
 */
export const getSelectedCategoryName = createSelector(
  getCurrentMenuCategories,
  getSelectedCategory,
  (categories, selectedCategory) => {
    if (selectedCategory === FAVORITES_ID) return FAVORITES_LABEL
    if (selectedCategory === ALL_ID) return ALL_LABEL

    return categories?.byId?.[selectedCategory]?.name || 'n/a'
  },
)
